import { Component } from '@angular/core';
import { Router ,RouterLink} from '@angular/router';
@Component({
  selector: 'app-terms-condtion-page',
  imports: [RouterLink],
  templateUrl: './terms-condtion-page.html',
  styleUrl: './terms-condtion-page.css'
})
export class TermsCondtionPage {
constructor(private router :Router){}
navigateAndScroll(route: string, x: number=0, y: number=0) {
    this.router.navigate([route]).then(() => {
      window.scrollTo(x, y);
    });
  }
     scrollToTop() {
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 0);
}

}
